import { ClipboardCheck } from 'lucide-react'

import { Card } from './ui/Card'
import { Button } from './ui/Button'
import { formatTimeOfDay } from '../utils/attendance'
import type { GroupSlot } from '../types/api'

interface CurrentTrainingCardProps {
  slots: GroupSlot[]
  onOpen: (slot: GroupSlot) => void
}

/**
 * «Сейчас идёт: Соколята, 17:00» на главной.
 *
 * Самый короткий путь к перекличке: тренер уже в зале, экран открывается
 * в один тап, не проходя через список групп.
 */
export function CurrentTrainingCard({ slots, onOpen }: CurrentTrainingCardProps) {
  // Занятий сейчас нет — карточку не показываем совсем, чтобы не занимать
  // место на главной пустым состоянием.
  if (slots.length === 0) return null

  return (
    <Card>
      <div className="flex flex-col gap-2" data-testid="current-training">
        <p className="text-[13px] uppercase" style={{ color: 'var(--text-hint)' }}>
          {slots.length === 1 ? 'Сейчас тренировка' : 'Сейчас тренировки'}
        </p>

        {slots.map((slot) => (
          <div key={`${slot.group_id}-${slot.start_time ?? ''}`} className="flex items-center gap-3">
            <span className="flex-1 text-[17px]" style={{ color: 'var(--text-primary)' }}>
              {slot.group_name}
              {formatTimeOfDay(slot.start_time) && (
                <span style={{ color: 'var(--text-secondary)' }}>
                  {' '}
                  · {formatTimeOfDay(slot.start_time)}
                </span>
              )}
            </span>

            <Button variant="primary" onClick={() => onOpen(slot)}>
              <ClipboardCheck size={18} /> Отметить
            </Button>
          </div>
        ))}
      </div>
    </Card>
  )
}
